











import { defineComponent } from "@vue/composition-api";
import { InputSystemSettings } from "@teacherskaya/api-provider/dist/api/SystemSettingsProvider";
import { Currency } from "@teacherskaya/api-provider/dist/api/CurrencyProvider";
import { $t } from "@/lib/helpers/i18nHelper";
import useAuthorityCheck from "@/hooks/useAuthorityCheck";
import { FormFields, FormValues, ListFields } from "@/types";
import CurrencyTitle from "@/views/PageSettingsCurrencies/components/CurrencyTitle.vue";
import BlockBase from "@/components/BlockBase.vue";
import BlockBaseForm from "@/components/BlockBaseForm.vue";

export default defineComponent({
  name: "BlockMainCurrency",
  components: { BlockBaseForm, CurrencyTitle, BlockBase },
  props: {
    mainCurrency: { type: String, required: true },
    currencyList: { type: Array as () => Currency[], required: true },
  },
  data() {
    return {
      editing: false,
    };
  },
  setup() {
    const canEdit = useAuthorityCheck("SystemSettings", "update_any");
    return {
      canEdit,
    };
  },
  computed: {
    fields(): FormFields {
      return [
        {
          name: "mainCurrency",
          title: "",
          type: "radio-group",
          value: this.mainCurrency,
          list: this.currencyList.reduce((out, item) => {
            out.push({
              value: item.name,
              text: $t(item.name),
            });
            return out;
          }, [] as ListFields),
        },
      ];
    },
  },
  methods: {
    save(values: FormValues) {
      const data: InputSystemSettings = {
        mainCurrency: values.mainCurrency || this.mainCurrency,
      };
      this.$emit("update", data);
      this.editing = false;
    },
  },
});
